export const mapUserGroupToForm = (values = {}) => ({
  ...values,
  name: values.name || '',
  communityApps: (values?.apps || []).map(ca => ({
    app: `${ca.installationTag}_${ca.communityTag}`,
    features: (ca.features || []).map(caf => ({
      feature: caf.tag,
      roles: (caf.roles || []).map(r => r.tag),
    })),
  })),
});
